import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DataTablesResponse {
  data?: any[];
  draw?: number;
  recordsFiltered?: number;
  recordsTotal?: number;
}
